import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  const [cta, setCta] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const delay = index === 0 ? 4500 : 7500;
    const showTimer = window.setTimeout(() => setVisible(true), delay);
    const rotateTimer = window.setTimeout(() => {
      setVisible(false);
      setIndex(value => (value + 1) % recentPurchases.length);
    }, delay + 5500);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(rotateTimer);
    };
  }, [dismissed, index]);
  useEffect(() => {
    const onScroll = () => setCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [name, place] = recentPurchases[index];
  return <>
      <AnimatePresence data-id="element-135" data-mp="drhuafmhkcc2">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 26,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 280,
        damping: 24
      }} className="fixed bottom-4 left-4 z-[60] max-w-[290px] overflow-hidden rounded-2xl border-[3px] border-gold bg-primary p-3 pr-8 shadow-[0_18px_42px_rgba(219,39,119,.45)]" aria-live="polite" data-id="element-136" data-mp="dpyd8mt09x98">
            <div className="absolute inset-y-0 left-0 w-1.5 bg-gold" data-id="element-137" data-mp="11gauwpe1z8d0" />
            <button onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-1 text-pink-100 transition-colors duration-150 ease-out hover:text-white" aria-label="Cerrar notificación" data-id="element-138" data-mp="15j779yd0288i">
              <XIcon className="h-3.5 w-3.5" data-id="element-139" data-mp="32j1z6dd2x2vb" />
            </button>
            <div className="flex gap-3" data-id="element-140" data-mp="32kwk3rocouze">
              <span className="h-fit rounded-full border-2 border-amber-100 bg-gold p-2 text-white shadow-sm" data-id="element-141" data-mp="3ga6reue4asvm">
                <ShoppingBagIcon className="h-5 w-5" data-id="element-142" data-mp="3bj8abslb1qrb" />
              </span>
              <div data-id="element-143" data-mp="3q8mfeohulm0w">
                <p className="flex items-center gap-1 text-[10px] font-black uppercase tracking-[.12em] text-gold" data-id="element-144" data-mp="3q84lvzmkllwo">
                  <CheckCircle2Icon className="h-3 w-3" data-id="element-145" data-mp="3l8i0v40i31db" /> Compra reciente
                </p>
                <p className="mt-1 text-xs leading-snug text-pink-50" data-id="element-146" data-mp="346jy91sxkt5">
                  <b className="text-white" data-id="element-147" data-mp="3uahhvwbim5g9">{name}</b> compró el libro digital{' '}
                  <b className="text-amber-200" data-id="element-148" data-mp="3u8evrndhgwgt">Combo Completo Jumping 2026</b>
                </p>
                <p className="mt-1 flex items-center gap-1 text-[10px] font-semibold text-pink-100" data-id="element-149" data-mp="24x4jsotzxdnl">
                  <MapPinIcon className="h-3 w-3 text-gold" data-id="element-150" data-mp="1zykuceg71jqh" />
                  {place} · Argentina · hace {index * 5 + 2} min
                </p>
              </div>
            </div>
          </motion.aside>}
      </AnimatePresence>

      <AnimatePresence data-id="element-151" data-mp="6mnjb6tm3akv">
        {cta && <motion.a href="#pricing" initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-3 left-3 right-3 z-50 rounded-2xl bg-primary py-3.5 text-center text-sm font-extrabold uppercase text-white shadow-lg shadow-primary/30 md:hidden" data-id="element-152" data-mp="6jrmjlti2ry0">
            🏃‍♀️ Quiero mi Combo Jumping →
          </motion.a>}
      </AnimatePresence>
    </>;
}